import React from 'react'
import SbEditable from 'storyblok-react'
import { getFixedGatsbyImage } from 'gatsby-plugin-storyblok-image'
import Img from 'gatsby-image'
import styled from 'styled-components'

import { useOpenModalFromEvent } from 'hooks'

import { Container, Row, Col } from 'components/Grid'
import { Section, Link } from 'components/Common'
import HubSpotFormModal from '../EventFormModal'

import { StyledLink, EventContent, EventStaticElemen, EventsCol } from './styles'

import WithEvents from '../WithEvents'

const MAX_AMOUNT = 4

function EventsSectionGrid({ blok, allEvents }) {
  const { modalOpen, toggleModalVisibility } = useOpenModalFromEvent()

  const events = allEvents.slice(0, MAX_AMOUNT)
  const eventsWithModals = events.filter(event => event.content.signup_form)

  const handleToggleModalVisibility = (ev, modalId) => {
    ev.preventDefault()
    toggleModalVisibility(modalId)
  }

  const EventCol = ({ content, id }) => {
    const ImageProps =
      content.image &&
      getFixedGatsbyImage(content.image, {
        width: 262,
        height: 140,
        downloadLocal: true,
      })
    const signUpForm = content.signup_form
    const signUpLink = content.signup_link

    return (
      <EventContent>
        {ImageProps && <Img fixed={ImageProps} />}
        <Link
          blok={{ url: signUpForm ? { url: '#' } : signUpLink }}
          {...(signUpForm && { onClick: ev => handleToggleModalVisibility(ev, id) })}
          type="textLink"
          withSmallUnderline
          size="big"
          css="margin: 25px 0 0 0; text-transform: none !important; border-top: none !important; max-width: 100%; font-size: 20px; align-items: flex-start !important; > img { padding-top: 10px; }"
        >
          <LinkText>{content.name}</LinkText>
        </Link>
      </EventContent>
    )
  }

  return (
    <SbEditable content={blok}>
      <Section
        paddingTop={blok.padding_top || 106}
        paddingBottom={blok.padding_bottom || 64}
        paddingTopMb={blok.padding_top_mobile || 120}
        paddingBottomMb={blok.padding_bottom_mobile || 80}
        css="background-color: transparent;">
        <Container>
          <Row>
            <Col width={[1, 1, 1, 3.8 / 10]} px={0}>
              <EventStaticElemen>
                <h5>{blok.heading}</h5>
                <p>{blok.paragraph}</p>
                <StyledLink blok={blok.button_link} type="textLink" withArrow size="standard">
                  {blok.button_text}
                </StyledLink>
              </EventStaticElemen>
            </Col>
            <EventsCol width={[1, 1, 1, 6.2 / 10]}>
              <Row>
                {events.map((el, i) => {
                  return (
                    <Col key={`event_element__${i}`} width={[1, 1, 1 / 2, 1 / 2]} px={0}>
                      {EventCol(el)}
                    </Col>
                  )
                })}
              </Row>
            </EventsCol>
          </Row>
        </Container>
      </Section>

      {eventsWithModals.length > 0 && eventsWithModals.map(event => event.uuid === modalOpen && (
        <HubSpotFormModal
          handleCloseModal={toggleModalVisibility}
          content={event.content}
          key={event.id}
        />
      ))}
    </SbEditable>
  )
}

export default WithEvents(EventsSectionGrid)

const LinkText = styled.span`
  height: 100%;
  overflow: hidden;
`
